import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { Preferences } from '@capacitor/preferences';

//import  firebase from 'firebase/compat/app';
//import { initializeApp } from 'firebase/app';
//import { getMessaging } from 'firebase/messaging';
import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';


async function setFcmToken(event) {

  //alert("IN SET TOKENT");
  //alert(event);

  Preferences.set({
      key: 'fcm_token',
      value: event,
  })
  
}

export function Push_Notification(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);





    useEffect(() => {
      // Request notification permission

     // alert("1");

      const firebaseConfig = {
          apiKey: "AIzaSyA8dIycNZrfe8z_mBhENMIGeHY2WOTrSRM",
          authDomain: "ghanaverified-c5f9f.ghanaverified.com",
          projectId: "ghanaverified-c5f9f",
          storageBucket: "ghanaverified-c5f9f.firebasestorage.app",
          messagingSenderId: "1039468587523",
          appId: "1:1039468587523:android:e0bb5304a2ddf7e594fc36",
          measurementId: ""
      };

     // const firebaseApp = initializeApp(firebaseConfig);
      //alert("3");

      //const messaging = getMessaging(firebaseApp);
      try{

      PushNotifications.requestPermissions().then(result => {

        //alert(result.receive);
        //alert(result);

        if (result.receive === 'granted') {
          // Register for push notifications
          //alert('BEFORE notification permission GRANTED');

          PushNotifications.register();
          //alert('Push notification permission GRANTED');


        } else {
          alert('Push notification permission not granted');
        }
      });
    }

      catch(error) {
        alert("IN ERROR");
        alert(error.message)
      }
      //alert("4");

      PushNotifications.addListener('registration', (token) => {
          //alert('FCM Token:', token.value);
          setFcmToken(token.value); // Store token
          authenticatedMerchent_context.changeFcmToken(token.value);
          sendFcmTokenToBackend(token.value); // Send the refreshed token to backend

        });

        //alert("5");

        PushNotifications.addListener('registrationRefresh', (token) => {
          //alert('FCM Token refreshed:', token.value);
          setFcmToken(token.value); // Update the token
          authenticatedMerchent_context.changeFcmToken(token.value);
          sendFcmTokenToBackend(token.value); // Send the refreshed token to backend
        });


      // Handle incoming push notifications
      PushNotifications.addListener('pushNotificationReceived', notification => {
          //alert('Notification received: - '+ notification);
          //alert(notification.title);
          //alert(notification.body);

          props.setNotificationData(`${notification.title}: ${notification.body}`);

      });
      //alert("6");

      
      // Handle notification action (when the notification is tapped)
      PushNotifications.addListener('pushNotificationActionPerformed', action => {
        //alert('Notification action performed: ' + JSON.stringify(action));

      });

      //alert("7");


    }, []);


     function sendFcmTokenToBackend(event)
     {

        //alert('In sendFcmTokenToBackend');
        //alert(event);
        //alert(window.location.origin);

         let formData = new FormData();

        //  if(authenticatedMerchent_context.accessRights[0] == 'admin')
        //  {
        //   formData.append('fcmToken_admin', event);
        // }
        // else
        // {
        formData.append('fcmToken', event);
        formData.append('fmc_accountID', authenticatedMerchent_context.acctID);
        formData.append('fmc_schema', authenticatedMerchent_context.schema);
        formData.append('fmc_businessType', authenticatedMerchent_context.authenticated);
        formData.append('fmcToken_access', authenticatedMerchent_context.accessRights[0]);


//        }
        //  formData.append('user', acctID);
        //  formData.append('xJobRequisitionID', props.data.requisitionID);
        //  formData.append('xJobApplicationID', props.data.applicationID);
        //  formData.append('xApplicantMobileNumber', applicant_phoneNumber);
        //  formData.append('sessionID', sessionID);
 

         const requestOptions = {
             enctype: 'multipart/form-data',
             method:'POST',
             //credentials: 'include',
             files: formData,
             body: formData,
             contentType: false,
             processData: false,
         }
         
         let url = '/save_fcm_token';

        //  if(authenticatedMerchent_context.accessRights[0] == 'admin')
        //  {
        //   url = '/save_fcm_token_admin';
        //  }
        //  else
        //  {
        //   url = '/save_fcm_token';

        //  }
 
         fetch(window.location.origin+url, requestOptions)
         .then(res => res.text())
         .then(data => {


             //alert(data);

              
         })
         .catch(error => {
             console.error(error);
         })
     }
     //alert("0");


    return (

        <React.Fragment>

        </React.Fragment>

    )
    //}   
}